import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEF = { currency: "EUR", number_format: "1,234.56", decimals: 2 };
const FmtCtx = createContext(DEF);
const SEP = { "1,234.56": [",", "."], "1.234,56": [".", ","], "1 234,56": [" ", ","], "1 234.56": [" ", "."] };
let CUR = DEF;

export function formatAmount(v, cfg = {}) {
  const dec = cfg.decimals ?? 2;
  const [th, de] = SEP[cfg.number_format] || SEP["1,234.56"];
  const n = Number(v || 0);
  const s = Math.abs(n).toFixed(dec);
  const [i, f] = s.split(".");
  const ip = i.replace(/\B(?=(\d{3})+(?!\d))/g, th);
  return (n < 0 ? "-" : "") + ip + (dec ? de + f : "");
}

export const money = (v, currency) => `${formatAmount(v, CUR)} ${currency || CUR.currency}`;

const pick = (r) => ({ currency: r.data.base_currency, number_format: r.data.number_format, decimals: r.data.decimals });

export function FmtProvider({ children }) {
  const [cfg, setCfg] = useState(DEF);
  const load = () => api.get("/accounting/fx/settings").then((r) => { CUR = pick(r); setCfg(CUR); }).catch(() => {});
  useEffect(() => { load(); }, []);
  return <FmtCtx.Provider value={{ ...cfg, reload: load }}>{children}</FmtCtx.Provider>;
}

export function useFmt() {
  const cfg = useContext(FmtCtx);
  const amt = (v) => formatAmount(v, cfg);
  const drcr = (v, normal = "debit") => { const n = Number(v || 0); if (!n) return `${formatAmount(0, cfg)}`; const side = n > 0 ? "Dr" : "Cr"; return `${formatAmount(Math.abs(n), cfg)} ${side}`; };
  return { ...cfg, amt, drcr, money: (v, currency) => `${formatAmount(v, cfg)} ${currency || cfg.currency}` };
}
